import dayjs from "dayjs";

interface FuncParams {
  /**
   * 毫秒时间戳
   * 例如：1647414400000
   */
  time: number | string;
  /**
   * 时间后添加文案，默认为前，例如：1年前
   */
  afterText?: string;
  /**
   * 是否反向比较时间，用于计算什么时候过期使用
   * 例如：
   *  1. 1年前，表示当前时间已经过去1年
   *  2. 1年后，表示当前时间还未过1年
   */
  reverse?: boolean;
  /**自定义时间单位 */
  customTimeMap?: [dayjs.QUnitType, string][];
  /**
   * 最大显示时间，超过这个时间不展示
   */
  maxShowTime?: [number, dayjs.QUnitType];
}
export default function getTimeDuration({
  time,
  afterText = "前",
  reverse,
  customTimeMap,
  maxShowTime,
}: FuncParams) {
  // 时间差
  let now = dayjs();
  let pre = dayjs(time);

  if (reverse) {
    const temp = pre;
    pre = now;
    now = temp;
  }

  // 最大显示时间，超过这个时间不展示
  if (maxShowTime && now.diff(pre, maxShowTime[1], true) > maxShowTime[0]) {
    return "";
  }

  const mapList = customTimeMap || [
    ["year", "年"],
    ["M", "月"],
    ["d", "天"],
    ["h", "小时"],
    ["m", "分钟"],
    ["s", "秒"],
  ];

  for (let i = 0; i < mapList.length; i++) {
    const [unit, unitText] = mapList[i];
    if (unit) {
      let diff = now.diff(pre, unit, true);
      if (diff >= 1) {
        return `${diff.toFixed()} ${unitText}${afterText}`;
      }
    }
  }

  return reverse ? "即将" : "刚刚";
}
